import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { MainLayoutComponent } from './main-layout/main-layout.component';
// import { FooterOnlyLayoutComponent } from './footer-only-layout/footer-only-layout.component';
// import { FooterComponent } from './footer/footer.component';
// import { HeaderComponent } from './header/header.component';
// import { SidebarComponent } from './sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { CleanLayoutComponent } from './clean-layout/clean-layout.component';
import { DataTablesModule } from 'angular-datatables';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { DocumentationLayoutComponent } from './documentation-layout/documentation-layout.component';
import { HeaderDocumentationComponent } from './header-documentation/header-documentation.component';
// import { SidebarDocumentationComponent } from './sidebar-documentation/sidebar-documentation.component';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  imports: [
    CommonModule,
    NgxJsonViewerModule,
    RouterModule.forChild([]),
    FlexLayoutModule,
    LazyLoadImageModule,
    MatMenuModule,
    // DataTablesModule
  ],
  exports: [
    MainLayoutComponent,
    CleanLayoutComponent,
    DocumentationLayoutComponent
  ],
  declarations: [
    MainLayoutComponent,
    CleanLayoutComponent,
    DocumentationLayoutComponent,
    FooterComponent,
    HeaderComponent,
    HeaderDocumentationComponent,
    SidebarComponent,
  ]
})
export class LayoutModule { }
